import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  descriptionCta: 'Please select an ID for verification:',
})
